module.exports = __webpack_public_path__ + "img/1.c188c91a.jpg";